import Footer from 'components/footer/Footer';
import NavbarBottom from 'components/navbar/bottom/NavbarBottom';
import NavbarTop from 'components/navbar/top/NavbarTop';
import NavbarVertical from 'components/navbar/vertical/NavbarVertical';
import React from 'react';

const OfflineFallback = () => {
  return (
    <>
      <div className={'container'}>
        <NavbarVertical />
        <div className={'content'}>
          <NavbarTop />
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              height: '80vh',
              textAlign: 'center',
              padding: '20px'
            }}
          >
            <h1>Oops! Sei offline 💔</h1>
            <p>Controlla la tua connessione e riprova.</p>
          </div>
          <Footer />
        </div>
      </div>
      <NavbarBottom />
    </>
  );
};

export default OfflineFallback;
